/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_Gbp_ConnectInputs */

const cs_integrations_gbp_connect = /** @type {(inputs: Integrations_Gbp_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Propojit Google Business`)
};

const en_integrations_gbp_connect = /** @type {(inputs: Integrations_Gbp_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect Google Business`)
};

/**
* | output |
* | --- |
* | "Connect Google Business" |
*
* @param {Integrations_Gbp_ConnectInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const integrations_gbp_connect = /** @type {((inputs?: Integrations_Gbp_ConnectInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Gbp_ConnectInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_integrations_gbp_connect(inputs)
	return cs_integrations_gbp_connect(inputs)
});